import { useCallback } from "react";
import { apiIsp, ApiManager, apiCompany } from '../../../../managers/api-manager';
import { GetResponseCompanyAuthorities, GetResponseCompanyDetailAuthorityDataEntity } from '../../../../module/api/api/isp-web/companies/authorities/index'

export const useGetAuth = () => {
  const getMasterAuth = useCallback(() => new Promise<GetResponseCompanyAuthorities[]>((resolve) => {
    apiIsp.companies().authorities().get().then((res) => {
      const data = (res as any)?.body.data;
      resolve(data ?? []);
    }).catch(ApiManager.errorFunc);
  }), []);

  const getCompanyAuth = useCallback((id: string) => new Promise<GetResponseCompanyDetailAuthorityDataEntity[]>((resolve) => {
    apiIsp.companies().authorities().getDetail(id).then((res) => {
      const data = (res as any)?.body.data;
      resolve(data ?? []);
    }).catch(ApiManager.errorFunc);
  }), []);
  const getCompanyAuthForCompany = useCallback(() => new Promise<GetResponseCompanyAuthorities[]>((resolve) => {
    apiCompany.members().authorities().get().then((res) => {
      const data = (res as any)?.body.data;
      resolve(data ?? []);
    }).catch(ApiManager.errorFunc);
  }), []);

  const getMasterUserIspAuth = useCallback((company_code: string) => new Promise<GetResponseCompanyAuthorities[]>((resolve) => {
    apiIsp.companies(company_code).members().authorities().get()
    .then((res) => {
      console.log(res);
      const data = (res as any)?.body.data as GetResponseCompanyAuthorities[];
      resolve(data ?? []);
    })
  }), []);

  const getMasterUserRestoreIspAuth = useCallback((company_code: string, member_id: string) => new Promise<GetResponseCompanyDetailAuthorityDataEntity[]>((resolve) => {
    apiIsp.companies(company_code).members().authorities().getDetail(member_id).then((res) => {
      const data = (res as any)?.body.data as GetResponseCompanyDetailAuthorityDataEntity[];
      resolve(data ?? []);
    }).catch(ApiManager.errorFunc);
  }), [])
  const getMasterUserRestoreCompanyAuth = useCallback((member_id: string) => new Promise<GetResponseCompanyDetailAuthorityDataEntity[]>((resolve) => {
    apiCompany.members().authorities().getDetail(member_id).then((res) => {
      const data = (res as any)?.body.data as GetResponseCompanyDetailAuthorityDataEntity[];
      resolve(data ?? []);
    }).catch(ApiManager.errorFunc);
  }), [])

  return { getMasterAuth, getCompanyAuth, getMasterUserIspAuth, getMasterUserRestoreIspAuth, getCompanyAuthForCompany, getMasterUserRestoreCompanyAuth }
}